export enum OfferConfigTextBlockSection {
  Contract = "CONTRACT",
  CoverLetter = "COVER_LETTER",
  Offer = "OFFER",
  QualityAssurance = "QUALITY_ASSURANCE",
  ServiceProgram = "SERVICE_PROGRAM",
}

export class OfferTextBlockSectionUtil {
  private static descriptions: {
    [key in OfferConfigTextBlockSection]: string;
  } = {
    [OfferConfigTextBlockSection.Contract]: "Vertrag",
    [OfferConfigTextBlockSection.CoverLetter]: "Anschreiben",
    [OfferConfigTextBlockSection.Offer]: "Angebot",
    [OfferConfigTextBlockSection.QualityAssurance]: "Mehrwerte & Referenzen",
    [OfferConfigTextBlockSection.ServiceProgram]: "Leistungsprogramm",
  };

  private static abbreviations: {
    [key in OfferConfigTextBlockSection]: string;
  } = {
    [OfferConfigTextBlockSection.Contract]: "Vertrag",
    [OfferConfigTextBlockSection.CoverLetter]: "Anschreiben",
    [OfferConfigTextBlockSection.Offer]: "Angebot",
    [OfferConfigTextBlockSection.QualityAssurance]: "Mehrwerte & Referenzen",
    [OfferConfigTextBlockSection.ServiceProgram]: "Leistungsprogramm",
  };

  static toString(type: OfferConfigTextBlockSection): string {
    return this.abbreviations[type];
  }

  static toLongString(type: OfferConfigTextBlockSection): string {
    return this.descriptions[type] || "Unknown";
  }
}
